import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { t } from 'i18next';
import { CollectionOpts } from 'json-api-hooks';
import React, { EventHandler } from 'react';

import useFieldOptions from '../.././Form/hooks/useFieldOptions';
import Spinner from '../../Loading/Spinner';
import { FormFieldOption, ResourceFieldAttributes } from '../ResourceForm';
import { InputProps, InputRenderer } from '../types';

import HiddenInput from './HiddenInput';

function handleChange(e: any, values: string[], onChange: EventHandler<any>) {
  const newValue = values?.slice() ?? [];

  if (e.target.checked) {
    newValue.push(e.target.value);
  } else {
    const index = values.indexOf(e.target.value);

    if (index !== -1) {
      newValue.splice(index, 1);
    }
  }

  onChange({ target: { value: newValue } });
}

const Checkboxes = ({
  inputProps: { name, onBlur, onChange, value },
  options,
}: {
  options: FormFieldOption[];
  inputProps: InputProps;
}) => {
  return options.map((item) => (
    <div key={`checkbox-${item.key}`}>
      <FormControlLabel
        checked={(value as string[])?.some((v) => v === item.key)}
        control={<Checkbox color="primary" id={item.key} value={item.key} />}
        label={item.label}
        name={name}
        value={item.key}
        onBlur={onBlur}
        onChange={(e) => handleChange(e, value, onChange)}
      />
    </div>
  ));
};

const CheckboxesInput = ({
  inputProps,
  options: optionsProp,
  required,
  resource,
  resourceOpts,
  resourceType,
}: InputRenderer) => {
  const { loading, options } = useFieldOptions(
    optionsProp,
    resource,
    resourceType,
    resourceOpts as CollectionOpts | ((props: ResourceFieldAttributes<void>) => CollectionOpts),
  );

  if (loading) {
    return <Spinner />;
  }

  return (
    <FormGroup>
      {required && <HiddenInput inputProps={inputProps} required={required} />}
      {options.length === 0 ? t('collection.empty') : <Checkboxes inputProps={inputProps} options={options} />}
    </FormGroup>
  );
};

export default CheckboxesInput;
